import Resource from '@/api/resources/Resource'

class SampleProcessingCaseService extends Resource {
    async getCaseWithPatientBySampleLabel(labId, samLabel) {
        return this.axios.get(`/sampleProcessing/laboratories/${labId}/cases/samples/${samLabel}/case`).then(response => response.data)
    }

    async getCaseWithPatientByCaseId(labId, casId) {
        return this.axios.get(`/sampleProcessing/laboratories/${labId}/cases/${casId}`).then(response => response.data)
    }

    async searchCaseByCasenumber(labId, caseNumber) {
        const params = { caseNumber }
        const response = await this.axios.get(`/sampleProcessing/laboratories/${labId}/cases/searchByNumber`, { params })
        return response.data
    }
}

export default new SampleProcessingCaseService()
